import { render, staticRenderFns } from "./LeaveSetupEdit.vue?vue&type=template&id=144f76a5"
import script from "./LeaveSetupEdit.vue?vue&type=script&lang=js"
export * from "./LeaveSetupEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports